module.exports = __webpack_public_path__ + "img/hrm-ashley.2aeec91.png";